<template>
  <div class="card" v-if="schemas">
    <header class="bandeau-modal card-header">
    </header>
    <div class="card-content">
      <h1 class="title is-size-3">
        {{$t('listeSchemaComptable.fusion.title')}}
      </h1>
      <error-msg-component :messages="messages" class="mgt-20px" :error="error" v-if="error"
                             :title="'addEditBailleur.error.problemOccurred'"
                             :withEmplyFields="true"
                             @close="error = $event"/>
      <p class="mgt-20px has-text-default">
        {{$t('listeSchemaComptable.fusion.text')}}
      </p>
      <v-client-table  :data="schemas"
        :columns="columns" :options="options" ref="tableSchemaComptableFusion">
        <div slot="selectedFusion" slot-scope="props" class="has-text-centered">
            <qd-radio v-model="idSelected" :native-value="props.row.id">
            </qd-radio>
        </div>
        <div slot="actif" slot-scope="props" class="has-text-centered">
            <b-checkbox v-model="props.row.actif" type="is-default"
                        class="pointer-events-none">
            </b-checkbox>
        </div>
        <div slot="libelle" slot-scope="props">
            {{ props.row.libelle }}
        </div>
        <div slot="type" slot-scope="props">
            {{props.row.type}}
            {{ $t(getLibelleType(props.row.type)) }}
        </div>
      </v-client-table>

      <div class="buttons">
        <qd-button type="is-light"
                  class="btn-modal-annuler"
                  @click="close()">
          {{$t('general.button.cancel')}}
        </qd-button>
        <qd-button type="is-info"
                  @click="fusion()">
          {{$t('listeSchemaComptable.fusion.fusionner')}}
        </qd-button>
      </div>
    </div>
  </div>
</template>

<script>

import { LISTE_TYPE_SCHEMA_COMPTABLE } from '@/configuration/parametrage/schemaComptableConf';
import {
  TEXTS, RESULTS_PER_PAGE, NO_PER_PAGE_VALUE, SORT_ICON,
} from '@/configuration/clientTableConf';
import errorMsgComponent from '@/components/general/errorMsgComponent';

export default {
  props: {
    schemas: {
      type: Array,
      required: true,
    },
  },
  data: () => ({
    idSelected: '',
    error: false,
    messages: [],
  }),
  components: {
    errorMsgComponent,
  },
  computed: {
    options() {
      return {
        sortIcon: SORT_ICON,
        headings: {
          libelle: this.$t('listeSchemaComptable.tab.libelle'),
          type: this.$t('listeSchemaComptable.tab.type'),
          compteNormal: this.$t('listeSchemaComptable.tab.compteNormal'),
          selectedFusion: '',
        },
        filterable: false,
        perPageValues: NO_PER_PAGE_VALUE,
        perPage: RESULTS_PER_PAGE,
        texts: TEXTS,
        columnsClasses: {
          archive: 'colonneSelected',
          edit: 'colonneSelected',
          delete: 'colonneSelected',
          selectedFusion: 'colonneSelected',

        },
        sortable: ['libelle', 'type', 'compteNormal'],
      };
    },
    columns() {
      return ['selectedFusion', 'libelle', 'type', 'compteNormal'];
    },
  },
  methods: {
    getLibelleType(type) {
      return LISTE_TYPE_SCHEMA_COMPTABLE.find((listeType) => {
        return type === listeType.code;
      }).libelle;
    },
    close() {
      this.$emit('close');
    },
    fusion() {
      this.messages = [];
      if (this.idSelected === '') {
        this.error = true;
        this.messages.push({ message: 'listeSchemaComptable.fusion.alert' });
        return;
      }
      this.error = false;
      this.$emit('fusion', this.idSelected);
    },
  },
  mounted() {
  },
};
</script>

<style>

</style>
